module.exports = __webpack_public_path__ + "img/history-dp.30eda6d9.png";